import React, {useEffect, useState} from 'react'
import {Navigate, useNavigate} from 'react-router-dom'
import {Container} from 'semantic-ui-react'
import {useAuth} from '../context/AuthContext'
import {reportApi} from '../misc/ReportApi'
import {handleLogError} from '../misc/Helpers'
import ReportForm from "./ReportForm";
import moment from "moment/moment";

function ReportFormPage() {
  const Auth = useAuth()
  const user = Auth.getUser()
  const isUser = user.role === 'USER'
  const navigate = useNavigate()

  const [pp, setPp] = useState('')
  const [vehicleType, setVehicleType] = useState('')
  const [tripDate, setTripDate] = useState('')
  const [startHour, setStartHour] = useState('00')
  const [startMin, setStartMin] = useState('00')
  const [firstBorderHour, setFirstBorderHour] = useState('00')
  const [firstBorderMin, setFirstBorderMin] = useState('00')
  const [secondBorderHour, setSecondBorderHour] = useState('00')
  const [secondBorderMin, setSecondBorderMin] = useState('00')
  const [endHour, setEndHour] = useState('00')
  const [endMin, setEndMin] = useState('00')
  const [total, setTotal] = useState('')
  const [notes, setNotes] = useState('')
  const [showCalendar, setShowCalendar] = useState(false);

  useEffect(() => {
  }, [])

  const handleCreateReport = async () => {
    try {
      const report = {
        pp: pp, vehicleType: vehicleType,
        tripDateStr: tripDate, startHour: startHour, startMin: startMin,
        firstBorderHour: firstBorderHour, firstBorderMin: firstBorderMin,
        secondBorderHour: secondBorderHour, secondBorderMin: secondBorderMin,
        endHour: endHour, endMin: endMin, total: total, notes: notes
      }
      await reportApi.createReport(user, report)
      navigate('/')
    } catch (error) {
      handleLogError(error)
    }
  }

  const handleDateChange = value => {
    setTripDate(moment(value).format( 'DD/MM/YYYY'))
    setShowCalendar(false)
  };

  const handleInputChange = (e, {name, value}) => {
    if (name === 'startHour') {
      setStartHour(value)
    } else if (name === 'pp') {
      setPp(value)
    } else if (name === 'vehicleType') {
      setVehicleType(value)
    } else if (name === 'startMin') {
      setStartMin(value)
    } else if (name === 'firstBorderHour') {
      setFirstBorderHour(value)
    } else if (name === 'firstBorderMin') {
      setFirstBorderMin(value)
    } else if (name === 'secondBorderHour') {
      setSecondBorderHour(value)
    } else if (name === 'secondBorderMin') {
      setSecondBorderMin(value)
    } else if (name === 'endHour') {
      setEndHour(value)
    } else if (name === 'endMin') {
      setEndMin(value)
    } else if (name === 'total') {
      setTotal(value)
    } else if (name === 'notes') {
      setNotes(value)
    }
  }

  if (!isUser) {
    return <Navigate to='/'/>
  }

  return (
    <Container>
      <ReportForm
        pp={pp}
        vehicleType={vehicleType}
        tripDate={tripDate}
        startHour={startHour}
        startMin={startMin}
        firstBorderHour={firstBorderHour}
        firstBorderMin={firstBorderMin}
        secondBorderHour={secondBorderHour}
        secondBorderMin={secondBorderMin}
        total={total}
        notes={notes}
        handleInputChange={handleInputChange}
        handleCreateReport={handleCreateReport}
        showCalendar={showCalendar}
        setShowCalendar={setShowCalendar}
        handleDateChange={handleDateChange}
      />
    </Container>
  )
}

export default ReportFormPage
